'use strict';

exports.Any = require('./properties/Any/regex');
exports.Cc  = require('./categories/Cc/regex');
exports.Cf  = require('./categories/Cf/regex');
exports.P   = require('./categories/P/regex');
exports.Z   = require('./categories/Z/regex');



/*****************
 ** WEBPACK FOOTER
 ** ./~/uc.micro/index.js
 ** module id = 1729
 ** module chunks = 0
 **/